import { render, staticRenderFns } from "./FormTemperature.vue?vue&type=template&id=ecb6825c"
import script from "./FormTemperature.vue?vue&type=script&lang=js"
export * from "./FormTemperature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports